import {
  LookupItem,
  OfferLiteResponse,
  OrganisationActivitiesPageResponse,
  OrganisationInteractionsPageResponse,
  OrganisationResponse,
  PostPageResponse,
  ProjectLiteResponse,
} from '@/api/generated'
import { emptyPageResponse } from '@/shared/interfaces/page-response'

export interface OrganisationViewModel {
  activities: OrganisationActivitiesPageResponse
  interactions: OrganisationInteractionsPageResponse

  lookup: {
    categories: LookupItem[]
    organisationTypes: LookupItem[]
    sectors: LookupItem[]
  }

  organisation: OrganisationResponse
  offers: OfferLiteResponse[]
  posts: PostPageResponse
  projects: ProjectLiteResponse[]
}

export const EmptyOrganisationViewModel: OrganisationViewModel = {
  activities: emptyPageResponse(),
  interactions: emptyPageResponse(),

  lookup: {
    categories: [],
    organisationTypes: [],
    sectors: [],
  },

  offers: [],

  organisation: {
    categories: [],
    email: '',
    id: -1,
    name: '',
    resources: [],
  },

  posts: emptyPageResponse(),
  projects: [],
}
